import { uuid } from './index';
/**
 * 额外数据模型 在link中meta只作为前端使用、在node中meta内容中除extParam外都是对服务端有意义的
 */
export class Meta {
    // 大小于（工具的符号）
    compare;
    // 配置key
    configKey;
    // 配置key的名称
    configName;
    // 条件父类型（个股条件/大盘条件）
    configType;
    // 扩展字段
    extParam;
    // 配置标识（后端用）
    processorPrefix;
    // 反弹回撤价差（买卖节点用）
    reboundRetreatPriceDiff;
    // 市场（主模型开始节点）
    regionType;
    // 股票范围（主模型开始节点）
    stockRange;
    // 节点值（条件、工具的值）
    values;
    // 选中的买卖点（起始节点用）- Array
    strategyPoints;
    // 前置节点（买入卖出节点用）- Array - 废弃
    preNode;
    // 选择的买入卖出类型: 1: 买入卖出 2：子模型（买卖节点用）
    buyAndSellType;
    // 选择的买入卖出方式: 1-涨势/跌势交易；2-反弹/回撤交易
    tradeType;
    // 子节点（塞的是子节点）
    children;
    // 节点类型（条件分类/条件/工具）
    type;
    // 后续订单是否需要校验行情 0-不需要 1-需要
    needCheckBeforeReleaseOrder;
    // 生成卖出/买入指令前 1-校验 0-不校验 买入/卖出放单
    needCheckBeforeReleaseCmd;
    // 生成卖出/买入指令前放单有效期
    needCheckBeforeReleaseCmdExpireDay;
    // 是否需要校验卖出路径的条件 0表示不检查，1表示检查
    needCheckSelfLinkBeforeReleaseCmd;
    // 立即卖出的盈亏比例
    executeSellingProfitRate;
    // 利润回撤比例配置
    ratioConfig;
    // 最小获利比例选项 0-盈利比例 1-个股振幅
    floatingRatioType;
    constructor({ compare = null, configKey = null, configName = null, configType = null, extParam = null, processorPrefix = null, reboundRetreatPriceDiff = null, regionType = null, stockRange = null, type = null, values = null, strategyPoints = [], buyAndSellType = null, tradeType = null, preNode = [], children = [], needCheckBeforeReleaseOrder = null, needCheckBeforeReleaseCmd = null, needCheckBeforeReleaseCmdExpireDay = null, needCheckSelfLinkBeforeReleaseCmd = null, executeSellingProfitRate = null, ratioConfig = null, floatingRatioType = null, }) {
        this.compare = compare;
        this.configKey = configKey;
        this.configName = configName;
        this.configType = configType;
        this.extParam = Object.assign({
            // 展示增加按钮（合并节点的父节点不展示-属性处理里处理）
            canInsert: true,
            // 工具和条件是否有强关系 1.3.132迭代去除了强关联不展示【+】的逻辑
            // toolAndConditionHasStrongRel: false,
            // 是否高亮
            isHighLight: false,
            // 是否为合并的特殊节点
            isMergeNode: false,
            // 是否展开
            isOpen: true,
            // 工具配置信息 (投管业务在用)
            configParams: null,
            // 是否在拖拽中
            isDragging: false,
            // 工具是否校验通过
            verifyStatus: false,
            // 工具是否是编辑态
            toolsIsEdit: false,
            // 收起数量
            shrinkNum: 0,
            // 是否为拖拽占位元素
            isDragElement: false,
            // 是否在合并链路上
            inMerge: false,
            // 收起节点是否禁用
            shrinkDisabled: false,
        }, extParam);
        this.processorPrefix = processorPrefix;
        this.reboundRetreatPriceDiff = reboundRetreatPriceDiff;
        this.regionType = regionType;
        this.stockRange = stockRange;
        this.type = type;
        this.values = values;
        this.strategyPoints = strategyPoints;
        this.buyAndSellType = buyAndSellType;
        this.tradeType = tradeType;
        this.preNode = preNode;
        this.children = children;
        this.type = type;
        this.needCheckBeforeReleaseOrder = needCheckBeforeReleaseOrder;
        this.needCheckBeforeReleaseCmd = needCheckBeforeReleaseCmd;
        this.needCheckBeforeReleaseCmdExpireDay = needCheckBeforeReleaseCmdExpireDay;
        this.needCheckSelfLinkBeforeReleaseCmd = needCheckSelfLinkBeforeReleaseCmd;
        this.executeSellingProfitRate = executeSellingProfitRate;
        this.ratioConfig = ratioConfig;
        this.floatingRatioType = floatingRatioType;
    }
}
/**
 * 节点数据结构
 */
export class Node {
    id = uuid();
    // 宽度
    width;
    // 高度
    height;
    // 坐标
    coordinate;
    // meta
    meta;
    constructor({ width = 240, height = 68, coordinate = [0, 0], meta = new Meta({}) }) {
        this.width = width;
        this.height = height;
        this.coordinate = coordinate;
        this.meta = new Meta(meta);
    }
}
/**
 * 连线数据结构
 */
export class Link {
    id = uuid();
    startId;
    endId;
    // 画线用
    startAt;
    // 画线用
    endAt;
    meta;
    constructor({ startId, endId, startAt = [240, 50], endAt = [0, 50], meta = null }) {
        this.startId = startId;
        this.endId = endId;
        this.startAt = startAt;
        this.endAt = endAt;
        this.meta = Object.assign({
            // 合并线路点击同时高亮标记id  默认为-1
            activeId: -1,
            // 是否高亮  默认为false
            isHighLight: false,
        }, meta);
    }
}
